import { StaticState } from "./SiteStateTypes";
import { projectManifests } from "../projects";
import { ProjectMap, Project, Asset, Icon } from "../Components/ProjectTypes";

export const staticStateLoader = (): StaticState => {
    const phoneNumber = Number(process.env.REACT_APP_PHONE_NUMBER);

    return { phoneNumber: phoneNumber, projectInfo: populateProjectInfo() };
}

const populateProjectInfo = (): ProjectMap => {
    const projectInfo: ProjectMap = {};

    projectManifests.forEach((projectManifestItem) => {
        const assets: Asset[] = [];
        projectManifestItem.files.forEach((file) => {
            assets.push({
                name: file.name,
                path: file.path
            })
        })

        const icons: Icon[] = [];
        projectManifestItem.icons.forEach((icon) => {
            icons.push(icon as Icon);
        })

        const currProject: Project = {
            key: projectManifestItem.name,
            name: projectManifestItem.name,
            tagline: projectManifestItem.tagline,
            fullDescription: projectManifestItem.fullDescription,
            icons: icons,
            assets: assets,
        };

        projectInfo[projectManifestItem.name] = currProject;
    })

    return projectInfo;
}